import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { IRegistrationEntry } from "../models/registrationentry.model";

@Injectable()
export class RegistrationEntryService {
    public getInitialTaskData(): Observable<IRegistrationEntry[]> {
        return of([
            {
                id: 1,
                complete: false,
                docid: "placeholder",
                role: "placeholder",
                lastupdated: "placeholder",
                userid: "placeholder",
                firstname: "placeholder",
                lastname: "placeholder",
                address1: "placeholder",
                address2: "placeholder",
                city: "placeholder",
                state: "placeholder",
                country: "placeholder",
                zip: "placeholder",
                mobilephone: "placeholder",
                email: "placeholder",
                company: "placeholder"
            }
        ]);
    }
}